import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import AdminCrud from "@/components/admin/AdminCrud";

export default function AdminVehicles() {
  const { data } = useQuery({ queryKey: ["cats"], queryFn: () => api.get("/admin/vehicle-categories").then((r) => r.data) });
  const cats = data?.items || [];
  return (
    <AdminCrud
      title="Vehicles"
      resource="vehicles"
      defaultItem={{ name: "", slug: "", category_id: "", seats: 4, ac: true, rental_type: "", description: "", features: [], image_url: "", gallery: [], price_hint: "", order: 1 }}
      fields={[
        { key: "name", label: "Name" },
        { key: "slug", label: "Slug (URL)" },
        { key: "category_id", label: "Category", type: "select", options: cats.map((c) => ({ value: c.id, label: c.name })) },
        { key: "seats", label: "Seats", type: "number" },
        { key: "ac", label: "AC", type: "switch" },
        { key: "rental_type", label: "Rental Type" },
        { key: "description", label: "Description", type: "textarea" },
        { key: "features", label: "Features (one per line)", type: "list" },
        { key: "image_url", label: "Primary Image", type: "image" },
        { key: "gallery", label: "Gallery URLs (one per line)", type: "list" },
        { key: "price_hint", label: "Price Hint (e.g. From ₹18/km)" },
        { key: "order", label: "Order", type: "number" },
      ]}
    />
  );
}
